// Deutsche Zahlen-/Währungsformatierung: Tausender-Punkt + Dezimal-Komma (z. B. 21.253,61 EUR)

export const formatNumberDE = (value) => {
  const n = parseFloat(value);
  return (Number.isFinite(n) ? n : 0).toLocaleString('de-DE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const formatEUR = (value, currency = 'EUR') => `${formatNumberDE(value)} ${currency || 'EUR'}`;

// Mengen-Format: Tausender-Punkt, aber Nachkommastellen nur wenn nötig (max. 3).
// Stück-Mengen (33.000) erscheinen als "33", echte Dezimalmengen als "1,5".
export const formatQtyDE = (value) => {
  const n = parseFloat(value);
  return (Number.isFinite(n) ? n : 0).toLocaleString('de-DE', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 3,
  });
};
